module.exports = __webpack_public_path__ + "static/media/lease2_img7.7cb7e889.jpg";